/*
 * Collection infinite scroll (Ajaxinate) + back/forward restoration.
 *
 * Problem: after scrolling down and loading extra pages, clicking a product and
 * pressing the browser "Back" button can drop you at the top of the collection
 * with only page 1 loaded. Browsers that keep the page in the bfcache restore it
 * natively, but many do not (Shopify pages frequently disqualify themselves from
 * the bfcache), so we rebuild the grid and restore the scroll position ourselves.
 */

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

function collectionScrollKey() {
  return 'collScroll:' + window.location.pathname + window.location.search;
}

var loadedPages = 1;

var ajaxinateInstance = null;

function getProductGrid() {
  return document.querySelector('#product-grid');
}

function getPaginationEl() {
  return document.querySelector('#AjaxinatePagination');
}

var advance = function advance() {
  loadedPages++;

  if (typeof quickAddButton == 'function') {
    quickAddButton();
  }
  if (typeof initAtcBtnAddToCart == 'function') {
    initAtcBtnAddToCart();
  }
  if (typeof initSizeVariantAddToCart == 'function') {
    initSizeVariantAddToCart();
  }
  if (typeof initQuickView == 'function') {
    initQuickView();
  }
  if (typeof initQuickViewSizeSelection == 'function') {
    initQuickViewSizeSelection();
  }
  // if(typeof initProductColorSwatches == 'function'){
  //   initProductColorSwatches();
  // }

  if (typeof initializeQuickView == 'function') {
    initializeQuickView();
  }
};


function attachAjaxinate() {
  if (ajaxinateInstance && typeof ajaxinateInstance.destroy == 'function') {
    try {
      ajaxinateInstance.destroy();
    } catch (e) {}
  }
  ajaxinateInstance = new Ajaxinate({
    container: '#product-grid',
    pagination: '#AjaxinatePagination',
    callback: advance,
  });
}

function currentPageInDom() {
  var paginationEl = getPaginationEl();
  var link = paginationEl ? paginationEl.querySelector('a') : null;
  var page = link ? parseInt(link.dataset.page, 10) : NaN;
  return isNaN(page) ? 1 : page;
}


var infinitescroll = {
  scolljs: function () {
    loadedPages = currentPageInDom();
    attachAjaxinate();
  },
};

function saveCollectionState() {
  try {
    sessionStorage.setItem(
      collectionScrollKey(),
      JSON.stringify({
        pages: loadedPages,
        scroll: window.pageYOffset || document.documentElement.scrollTop || 0,
      })
    );
  } catch (e) {}
}

function readCollectionState() {
  try {
    return JSON.parse(sessionStorage.getItem(collectionScrollKey()));
  } catch (e) {
    return null;
  }
}

function fetchNextPage(done) {
  var paginationEl = getPaginationEl();
  var link = paginationEl ? paginationEl.querySelector('a') : null;
  if (!link) {
    done(false);
    return;
  }

  var request = new XMLHttpRequest();
  request.open('GET', link.href);
  request.responseType = 'document';
  request.onreadystatechange = function () {
    if (request.readyState !== 4) return;
    if (request.status !== 200) {
      done(false);
      return;
    }
    var grid = getProductGrid();
    var newContainer = request.responseXML.querySelector('#product-grid');
    var newPagination = request.responseXML.querySelector('#AjaxinatePagination');
    if (grid && newContainer) {
      grid.insertAdjacentHTML('beforeend', newContainer.innerHTML);
    }
    if (paginationEl) {
      paginationEl.innerHTML = newPagination ? newPagination.innerHTML : '';
    }
    advance();
    done(true);
  };
  request.send();
}

function applyScroll(target) {
  if (!target) return;
  var tries = 0;
  (function tick() {
    window.scrollTo(0, target);
    tries++;
    var current = window.pageYOffset || document.documentElement.scrollTop;
    if (Math.abs(current - target) <= 2 || tries >= 15) return;
    setTimeout(tick, 120);
  })();
}

function restoreCollection(state) {
  var targetPages = state.pages || 1;
  var targetScroll = state.scroll || 0;

  function step() {
    if (document.documentElement.scrollHeight - window.innerHeight >= targetScroll) {
      window.scrollTo(0, targetScroll);
    }
    if (loadedPages >= targetPages) {
      applyScroll(targetScroll);
      attachAjaxinate();
      return;
    }
    fetchNextPage(function (loaded) {
      if (!loaded) {
        applyScroll(targetScroll);
        attachAjaxinate();
        return;
      }
      step();
    });
  }

  step();
}

function isBackForwardNavigation() {
  var entries = performance.getEntriesByType && performance.getEntriesByType('navigation');
  if (entries && entries.length) {
    return entries[0].type === 'back_forward';
  }
  return performance.navigation && performance.navigation.type === 2;
}

function initCollection() {
  if (!getProductGrid()) return;
  var state = readCollectionState();
  if (isBackForwardNavigation() && state) {
    restoreCollection(state);
  } else {
    infinitescroll.scolljs();
  }
}

initCollection();

if (!window.__collectionScrollListenersBound) {
  window.__collectionScrollListenersBound = true;

  var saveThrottle = null;
  window.addEventListener(
    'scroll',
    function () {
      if (saveThrottle) return;
      saveThrottle = setTimeout(function () {
        saveThrottle = null;
        saveCollectionState();
      }, 200);
    },
    { passive: true }
  );

  window.addEventListener('pagehide', saveCollectionState);
}
